import { connect } from "react-redux";
import Dashboard from "../../Components/DashboardComponent/Dashboard";
import {setMyAgentProfile} from "../../Redux/Actions/myAgentProfileActions"
import { setScope } from "../../Redux/Actions/scopeActions";
import {setQueues} from "../../Redux/Actions/queuesActions"
import { setGroups } from "../../Redux/Actions/groupsActions";
import { setCallFlows } from "../../Redux/Actions/callFlowsActions";
import { setSupervisedAgentIds,setSupervisedAgentDetails } from "../../Redux/Actions/agentsActions";

import { setAgentIds } from "../../Redux//Actions/agentsActions";
const mapDispatchToProps = (dispatch) => ({
  setMyAgentProfile: (agent) => dispatch(setMyAgentProfile(agent)),
  setScope: (scope) => dispatch(setScope(scope)),
  setQueues: (queues) => dispatch(setQueues(queues)),
  setGroups: (groups) => dispatch(setGroups(groups)),
  setCallFlows: (callFlows) => dispatch(setCallFlows(callFlows)),
  setSupervisedAgentIds: (SupervisedAgentIds) => dispatch(setSupervisedAgentIds(SupervisedAgentIds)),
  setSupervisedAgentDetails: (supervisedAgentData) => dispatch(setSupervisedAgentDetails(supervisedAgentData)), 
  setAgentIds: (AgentIds) => dispatch(setAgentIds(AgentIds)),
});

export default connect(null, mapDispatchToProps)(Dashboard);
